import styled from 'styled-components';

import { Text } from '../../components';
import { COLORS, MOBILE, SPACE } from '../../theme/tokens';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[20]};
  margin-top: ${SPACE[16]};
`;

export const Layout = styled.div`
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: ${SPACE[24]};
  align-items: start;

  ${MOBILE} {
    grid-template-columns: 1fr;
  }
`;

/** The editor's column (it may not push the grid wider than the screen). */
export const EditorColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
  min-width: 0;
`;

/** On a phone, above the editor: back to the route list, and the language picker. */
export const MobileEditorHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[12]};
`;

export const MobileLanguage = styled.div`
  min-width: 140px;
`;

export const SkeletonStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

export const Failure = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${SPACE[12]};
`;

export const ConfirmBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;

export const ConfirmLine = styled(Text)`
  font-size: 14px;
  color: ${COLORS.text};
`;

export const ConfirmNote = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

export const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${SPACE[8]};
`;
